import request from '@/utils/request'

export function getAllParams() {
  return request({
    url: '/api/admin/params',
    method: 'get'
  })
}

export function getParamsByCategory(category) {
  return request({
    url: `/api/admin/params/category/${category}`,
    method: 'get'
  })
}

export function getParamByKey(key) {
  return request({
    url: `/api/admin/params/${key}`,
    method: 'get'
  })
}

export function updateParamValue(key, value) {
  return request({
    url: `/api/admin/params/${key}`,
    method: 'put',
    data: { value }
  })
}

export function updateParamValues(params) {
  return request({
    url: '/api/admin/params/batch',
    method: 'put',
    data: params
  })
}

export function refreshCache() {
  return request({
    url: '/api/admin/params/refresh',
    method: 'post'
  })
}

export function getCachedParams() {
  return request({
    url: '/api/admin/params/cached',
    method: 'get'
  })
}
